/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_IdealistaInputs */

const cs_enum_idealista = /** @type {(inputs: Enum_IdealistaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealista`)
};

const en_enum_idealista = /** @type {(inputs: Enum_IdealistaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealista`)
};

/**
* | output |
* | --- |
* | "Idealista" |
*
* @param {Enum_IdealistaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_idealista = /** @type {((inputs?: Enum_IdealistaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_IdealistaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_idealista(inputs)
	return cs_enum_idealista(inputs)
});